import { render, staticRenderFns } from "./CallUs.vue?vue&type=template&id=031f54a0&scoped=true&"
import script from "./CallUs.vue?vue&type=script&lang=js&"
export * from "./CallUs.vue?vue&type=script&lang=js&"
import style0 from "./CallUs.vue?vue&type=style&index=0&id=031f54a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031f54a0",
  null
  
)

export default component.exports